import React, { useState, useEffect } from "react";
import axios from "axios";
import {ToastContainer, toast } from "react-toastify";
import { getTrans as t } from "../../../../Localization/translations";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import PaymentChangePane from "./PaymentChangePane";
import ContractVersionPane from "./ContractVersionPane";
import EditContractService from "../../../../services/contract/editContractService";
import AmortizationSchedule from "../AmortSchedulDetail/CalculateAmortSchedule";
import AmortizationScheduleArrears from "../AmortSchedulDetail/ArrearsAmortSchedule";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import

// Helper to resolve contract id from different shapes
// const resolveContractId = (contract) => {
//   if (!contract) return null;
//   if (typeof contract === "number") return contract;
//   return contract.id || contract.contractID || contract.contract_id || null;
// };

export default function ContractModification({ contract, contractdetails }) {
  const [modificationType, setModificationType] = useState("PaymentChange");
  const [newTerm, setNewTerm] = useState("");
  const [termError, setTermError] = useState("");

  const [paneOpen, setPaneOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0); // used to refresh version pane after save

  const [contractId,setContractID] = useState(contract);
  const [showAmortization, setShowAmortization] = useState(false);

  const [calu, SetCalu] = useState([]);
  const [amortcalculation, SetAmortCaluculation] = useState([]);
  const [amortError, setAmortError] = useState("");
  const [draftid, setDraftid] = useState(null);
  const [showConfirmActivate, setShowConfirmActivate] = useState(false);
  const [newInterestRate, setNewInterestRate] = useState("");


  useEffect(() => {
    // nothing for now
  }, []);

  const handleNewTermChange = (e) => {
    const val = e.target.value;
    // basic validation: newTerm cannot be smaller than existing (if provided)
    if (contractdetails && contractdetails.contract_term && val) {
      if (parseInt(val, 10) < parseInt(contractdetails.contract_term, 10)) {
        setTermError("New term cannot be less than current term");
      } else {
        setTermError("");
      }
    }
    setNewTerm(val);
  };

  const submitModification = async () => {
    if (!modificationType) {
      toast.error("Please select modification type");
      return;
    }

    if (modificationType === "ExtendTerm") {
      if (!newTerm || termError) {
        toast.error("Please enter valid new term");
        return;
      }

      try {
        await axios.post(
          API + `contracts/contracts/${contractId}/modify/`,
          {
            amendment_type: "EXTEND_TERM",
            reason: "Term changed",
            new_term: newTerm,
            payment_schedule: [],
          },
          { headers: authHeader() }
        );

        toast.success("Extend term draft created");
        setRefreshKey((k) => k + 1);
      } catch (err) {
        console.error(err);
        toast.error("Failed to create extend term draft");
      }
    }

    if (modificationType === "PaymentChange") {
      // open payment pane so user edits and saves — submitModification is not used for payment change
      setPaneOpen(true);
    }
  };

  const [contracts, setContract] = useState(null);         // active or draft


  useEffect(() => {
    loadContract(contractId);
  }, [contractId]);

  const loadContract = async (id) => {
    const res = await  EditContractService.getContract(id).then((response)=>{
  
    });
    setContract(await res.data);
  };

  const handleSaveModification = async (rowsData) => {
    if (!contractId) {
      toast.error("Contract id missing");
      return;
    }

    // const payload = {
    //   amendment_type: "PAYMENT_CHANGE",
    //   reason: "Payment schedule updated",
    //   payment_schedule: editableRows.map((r) => ({
    //     payment_type: r.payment_type || r.paymenttype || "Rent",
    //     no_of_payments: r.no_of_payments || r.no_of_payments === 0 ? r.no_of_payments : r.noOfPayments || r.count,
    //     amount: parseFloat(r.amount),
    //     payment_frequency: r.payment_frequency || r.payment_frequency || r.paymentFrequency || "Monthly",
    //     start_date: r.start_date, // assume already yyyy-mm-dd string
    //     end_date: r.end_date,
    //     periods: r.no_of_payments || r.count,
    //     paymentstart_date: r.paymentstart_date || r.start_date,
    //   })),
    // };

    // try {
    //   await axios.post(API + `contracts/contracts/${contractId}/modify/`, payload, {
    //     headers: authHeader(),
    //   });

    //   toast.success("Payment change draft created");
    //   setPaneOpen(false);
    //   setRefreshKey((k) => k + 1);
    // } catch (err) {
    //   console.error(err);
    //   toast.error("Error creating payment modification draft");
    // }
    const payload = rowsData.map((r) => ({
      payment_type: r.payment_type,
      no_of_payments: r.no_of_payments,
      amount: parseFloat(r.amount),
      payment_frequency: r.payment_frequency,
      start_date: r.start_date,
      end_date: r.end_date,
      periods: r.no_of_payments,
      paymentstart_date: r.paymentstart_date,
      is_historical: r.is_historical, 
    }));
    try {
    // 1️⃣ REQUEST OR FETCH EXISTING DRAFT
    const draftRes = await axios.post(
      API + `contracts/contracts/${contractId}/modify/`,
      { amendment_type: "PAYMENT_CHANGE",
        payment_schedule : payload
       },
      { headers: authHeader() }
    );

    const draftId = draftRes.data.draft_contract_id;

    // 2️⃣ SPLIT ROWS
    // const lockedRows = rowsData.filter(r => r.is_historical === true);
    const editableRows = rowsData.filter(r => r.is_historical === false);

    if (editableRows.length === 0) {
      toast.error("No editable schedule to update.");
      return;
    }

    // 3️⃣ PREP PAYLOAD
    // const payload = editableRows.map((r) => ({
    

    // 4️⃣ UPDATE SCHEDULE
    await axios.post(
      API + `contracts/contracts/update-payment-schedule/${draftId}/`,
      payload,
      { headers: authHeader() }
    );

    // 🔥 RECALCULATE IRR AFTER SAVE
      const irrRes = await axios.post(
        `${API}contracts/contractmodiir/`,
        { id: draftId },
        { headers: authHeader() }
      );
    toast.success("Draft payment schedule updated.");
    setPaneOpen(false);
    setRefreshKey(k => k + 1);

  } catch (err) {
    console.error(err);
    toast.error("Error saving modification");
  }
  };

  const [contractsVersions, setContractVersions] = useState([]);
  const [contractiir,setContractIIR]  = useState(0);
  const [draftContract, setDraftContract] = useState(null);
  const [totalRent, setTotalRent] = useState(0);
  const [totalonetimefee, setOneTimeFeeSum] = useState(0);
  useEffect(() => {
  axios
    .get(`${API}contracts/contracts/${contractId}/versions/`, {
      headers: authHeader(),
    })
    .then((res) => {
      const versions = res.data.versions || [];

      // ✅ find latest ContractMod
      const draft = versions
        .filter(v => v.status === "ContractMod")
        .sort((a, b) => b.version - a.version)[0];

      setDraftid(draft ? draft.id : null);

      if (draft) {
        const contract = draft.contracts?.[0] || null;

        setDraftContract(contract);

        // ✅ THESE come from VERSION, not contract
        setTotalRent(draft.payment_rent_sum || 0);
        setOneTimeFeeSum(draft.one_time_fee_sum || 0);

        setContractIIR(contract?.new_irr || 0);
      } else {
        setDraftContract(null);
        setTotalRent(0);
        setOneTimeFeeSum(0);
        setContractIIR(0);
      }
    });
      // const pending = res.data.versions.find(
      //   (v) => v.status === "ContractMod"
      // );
      // setDraftid(pending ? pending.id : null);
      
      // setContractVersions(res.data.contracts); 
      // if (pending && pending.contracts && pending.contracts.length > 0) {
      //   const contract = pending.contracts[0];
        
      //   setDraftContract(contract); 
      //   setTotalRent(contract.payment_rent_sum);
      //   setOneTimeFeeSum(contract.one_time_fee_sum);      // ✅ store draft contract
      //   // choose which IRR you want
      //   setContractIIR(contract.new_irr);
      // } else {
      //   setDraftContract(null);

      //   setContractIIR(0);
      // }


      // if (pending) {
      //   loadVersionPaymentSchedule(pending.id);
      // } else {
      //   loadOriginalPaymentDetails();
      // }
    // });
}, [paneOpen]);
// const effectiveContractId = draftid || contractId;
const effectiveContractId = draftid ;

// const effectiveContract = draftContract || contractdetails;
const effectiveContract = draftContract ;

  useEffect(() => {
  if (!effectiveContractId) return;

  const loadAmortization = async () => {
    try {
      const response = await axios.get(
        // `${API}contracts/amortCalculation/?id=${effectiveContractId}`,
        `${API}contracts/modamortCalculation/?id=${effectiveContractId}`,
        { headers: authHeader() }
      );

      SetCalu(response.data.response || []);
      SetAmortCaluculation(response.data.response || []);
      setAmortError(response.data.errors || "");

    } catch (error) {
      SetCalu([]);
      SetAmortCaluculation([]);
      setAmortError("");
      console.error("Error fetching amortization:", error);
    }
  };

  loadAmortization();

}, [
  paneOpen,
  effectiveContractId,   // 🔥 version-2 OR original
  contractdetails?.paymentrule,
  contractdetails?.paymentfrequency,
  contractdetails?.financed_amount,
  contractdetails?.contract_iir,
  contractdetails?.residual,
  contractdetails?.start_date,
]);
const totalIncome = (calu || []).reduce(
  (sum, val) => sum + (val.income || 0),
  0
);

const [activeLoading, setActiveLoading] = useState(false);
const navigate = useNavigate();
const [paymentDetailsForActivation, setPaymentDetailsForActivation] = useState([]);

console.log("paymentDetailsForActivation", paymentDetailsForActivation);
const handleActivateVersion  = () => {
  setActiveLoading(true);

  axios.post(
    `${API}contracts/contracts/activate-modification/${draftid}/`,
    {
      items: paymentDetailsForActivation,   // SAME payload
      amort: calu             // SAME payload
    },
    { headers: authHeader() }
  ).then((response) => {
    setActiveLoading(false);

    if (response.data.success) {
      toast.success(response.data.response, { autoClose: 1000 });

      setTimeout(() => {
        navigate("/contract");
      }, 1500);

    } else {
      toast.error(response.data.error || "Activation failed");
    }
  }).catch(() => {
    setActiveLoading(false);
    toast.error("Activation failed");
  });
};


const submitInterestRateChange = async () => {
  if (!newInterestRate) {
    toast.error("Please enter new interest rate");
    return;
  }

  try {
    await axios.post(
      `${API}contracts/contracts/${contractId}/modify/`,
      {
        amendment_type: "INTEREST_RATE_CHANGE",
        // new_interest_rate: parseFloat(newInterestRate),
      },
      { headers: authHeader() }
    );

    toast.success("Interest rate change draft created");
    setRefreshKey((k) => k + 1);
  } catch (err) {
    toast.error("Failed to create interest rate change");
  }
};

const abandonContract = async () => {
  if (!draftid) {
    toast.error("No draft to delete");
    return;
  }

  confirmAlert({
    title: "",
    message: "Are you sure you want to delete this amendment?",
    buttons: [
      {
        label: "Yes",
        onClick: async () => {
          try {
            await axios.delete(
              `${API}contracts/contractsmod/${draftid}/delete-mod/`,
              { headers: authHeader() }
            );

            toast.success("Amendment abandoned");

            // Reset state
            setDraftid(null);
            setDraftContract(null);
            // setOpenPane(false);

            // Reload
            window.location.reload();

          } catch (e) {
            toast.error("Failed to delete amendment");
          }
        },
      },
      {
        label: "No",
      },
    ],
  });
};

  return (
    <div className="container-fluid px-3">
      <ToastContainer />
      {/* Modification Type Selector */}
      <div className="card mt-3 ">
        <div className="card-body col-md-4">
          <label className="col-xl-6 col-form-label">{t("Modification Type")}</label>

          <select
            className="form-control col-xl-4"
            value={modificationType}
            onChange={(e) => setModificationType(e.target.value)}
          >
            <option value="">Select</option>
            <option value="ExtendTerm">{t("Extend Term")}</option>
            <option value="PaymentChange">{t("Payment Change")}</option>
            {contractdetails?.contract_type === "Loan" && (
              <option value="InterestRateChange">Interest Rate Change</option>
            )}

          </select>
        </div>
      </div>

      {/* Extend Term Block */}
      {modificationType === "ExtendTerm" && (
        <div className="card mt-3">
          <div className="card-body">
            <div className="form-group row">
              <div className="col-xl-6 d-flex" style={{ justifyContent: "space-between" }}>
                <span className="sub-title tc">{t("Current Term")}</span>
                <span className="party-detail-font">{contractdetails?.contract_term}</span>
              </div>

              <div className="col-xl-6">
                <label className="col-form-label required">{t("New Term")}</label>
                <input type="number" className="form-control" value={newTerm} onChange={handleNewTermChange} />
                {termError && <div className="invalid-feedback d-block">{termError}</div>}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Payment Change Block */}
      {modificationType === "PaymentChange" && (
        <div className="card mt-3">
          <div className="card-body">
            {/* <button className="btn btn-outline-primary" onClick={() => setPaneOpen(true)}>
              {t("Edit Payment Schedule")}
            </button> */}
            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-primary"
                onClick={() => {
                  setShowAmortization(false);
                  setPaneOpen(true);
                }}
              >
                {t("Edit Payment Schedule")}
              </button>

              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowAmortization(true)}
              >
                {t("Amortization")}
              </button>
              {draftid && (
            <button
                className="btn btn-secondary"
                onClick={abandonContract}
              >
                {/* Abandon Contract */}
                Delete
              </button>
            )}&nbsp;
              {draftid && (
                <button
                  className="btn btn-primary"
                  onClick={() => setShowConfirmActivate(true)}
                >
                  Activate
                </button>
              )}

              
            </div>
            {showConfirmActivate && (
  <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Confirm Activation</h5>
        </div>

        <div className="modal-body">
          <p>
            Are you sure you want to activate this contract modification?
            <br />
            <strong>This will replace the current active contract.</strong>
          </p>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowConfirmActivate(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleActivateVersion}
          >
            Activate
          </button>
        </div>
      </div>
    </div>
    <div className="modal-backdrop fade show"></div>
  </div>
)}

           

            {/* <PaymentChangePane
              isOpen={paneOpen}
              onClose={() => setPaneOpen(false)}
              contractId={contractId}
              contractdetails={contractdetails}
              onSave={(payload) => handleSaveModification(payload)}
            /> */}
            {!showAmortization && (
            <PaymentChangePane
              isOpen={paneOpen}
              onClose={() => setPaneOpen(false)}
              contractId={contractId}
              contractdetails={contractdetails}
              onSave={(payload) => handleSaveModification(payload)}
              onPaymentDetailsChange={(details) =>
                setPaymentDetailsForActivation(details)
              }
            />
          )}

          {showAmortization && (
            contractdetails.paymentrule ==='Arrears' ? (
                                    <AmortizationScheduleArrears
                                      startdate={contractdetails.start_date}
                                      totalIncome={totalIncome}
                                      totalRent={totalRent}
                                      paymentfrequency={contractdetails.paymentfrequency}
                                      financedamount={contractdetails.financed_amount}
                                      contract_term={contractdetails.contract_term}
                                      feesontime={totalonetimefee}
                                      contractiir={contractiir}
                                      paymentrule={contractdetails.paymentrule}
                                      paymentamount={contractdetails.rentamount}
                                      numberofpayment={contractdetails.no_of_payments}
                                      residual={contractdetails.residual}
                                      setarrears={calu}
                                      amortcal={amortcalculation}
                                      contracttype={contractdetails.contract_type}
                                      amortError={amortError}
                                    />
                                  // <AmortizationScheduleArrears
                                  //   startdate={start_date}
                                  //   key={key}
                                  //   totalIncome={totalIncome}
                                  //   totalRent={totalRent}
                                  //   paymentfrequency={paymentfrequency}
                                  //   financedamount={financed_amount}
                                  //   deposit_amount={deposit_amount}
                                  //   contract_term={contract_term}
                                  //   feesontime={totalonetimefee}
                                  //   contractiir={contract_iir}
                                  //   paymentrule={paymentrule}
                                  //   paymentamount={rentamount}
                                  //   numberofpayment={numberofpayment}
                                  //   residual={residual}
                                  //   setarrears={calu}
                                  //   amortcal={amortcalculation}
                                  //   contracttype={contract_type}
                                  //   amortError={amortError}
                                  // />
                                ) : (
                                  <AmortizationSchedule
                                     startdate={contractdetails.start_date}
                                      totalIncome={totalIncome}
                                      totalRent={totalRent}
                                      paymentfrequency={contractdetails.paymentfrequency}
                                      financedamount={contractdetails.financed_amount}
                                      contractiir={contractiir}
                                      contract_term={contractdetails.contract_term}
                                      feesontime={totalonetimefee}
                                      paymentrule={contractdetails.paymentrule}
                                      paymentamount={contractdetails.rentamount}
                                      numberofpayment={contractdetails.no_of_payments}
                                      residual={contractdetails.residual}
                                      setarrears={calu}
                                      amortcal={amortcalculation}
                                      contracttype={contractdetails.contract_type}
                                      amortError={amortError}
                                  />
                                )
            // <ContractPaymentDetails
            //   contractDate={contractdetails.start_date}
            //   paymentRule={contractdetails.paymentrule}
            //   paymentFrequency={contractdetails.paymentfrequency}
            //   noTerms={contractdetails.contract_term}
            //   contract_type={contractdetails.contract_type}
            // />
          )}
          

            <ContractVersionPane contractId={contractId} refreshKey={refreshKey} />
          </div>
        </div>
      )}
      {/* {modificationType === "InterestRateChange" && (
  <div className="card mt-3">
    <div className="card-body">
      <div className="row">
        <div className="col-md-6">
          <label>Current Interest Rate</label>
          <input
            className="form-control"
            value={contractdetails?.iir}
            disabled
          />
        </div>

        <div className="col-md-6">
          <label>New Interest Rate</label>
          <input
            type="number"
            step="0.01"
            className="form-control"
            value={newInterestRate}
            onChange={(e) => setNewInterestRate(e.target.value)}
          />
        </div>
      </div>

      <button
        className="btn btn-primary mt-3"
        onClick={submitInterestRateChange}
      >
        SAVE
      </button>
    </div>
  </div>
)} */}

      {/* Submit Button */}
      <div className="text-end mt-3">
        {/* <button className="btn btn-primary" onClick={submitModification}>
          {t("Create Modification Draft")}
        </button> */}
      </div>
    </div>
  );
}
